import React from 'react'
import { Table, Card, Tooltip, Button, Menu, Icon } from 'antd'


export default ({date_selection_ranges=[], selected_date_range,
                    selected_year, loading, build_columns,
                    has_write_perm, data_source, toggle_settings,
                    on_toggle_set_alert, on_selected_date_range_change, on_add_product}) => {

    const this_year = new Date().getFullYear()
    const years     = [(this_year-1).toString(), this_year.toString(), (this_year+1).toString()]

    const Legend = () => (
        <div className='finance-legend'>
            <Menu
                onClick      = {e=>on_selected_date_range_change(e.key)}
                selectedKeys = {[(selected_year||'').toString()]}
                mode         = "horizontal">
                {years.map(year=> <Menu.Item key={year}>{year}</Menu.Item>)}
            </Menu>

            <div>
                <Tooltip title={'Add Custom Service'} placement={'left'}>
                    <Button type="primary" shape="circle" icon="plus" size={'small'} style={{'margin':'10px'}} onClick={on_add_product}/>
                </Tooltip>
            </div>

            {/*<div className={'warnings'}>
                <div><span className='circle warning' />Sub budget not matching parent budget</div>
                <div><span className='circle danger' />Service reaching alert value</div>
            </div>*/}
        </div>
    )

    /*let scroll = 1800
    const columns = build_columns()
    if(columns.length && columns.length >2){
        let cols = columns[1].children.length + columns[2].children.length
        let ann  = columns[3].children.length

        scroll = ((17/columns[1].children.length) + (17/columns[2].children.length)) * 100 + (columns[3].children.length * 150)
        //debugger
    }*/

    return (
        <Card title='Finance Tracking' className='finance-table'>
            <Legend/>
            <Table columns    = {build_columns()}
                   dataSource = {data_source}
                   //loading    = {!data_source.length && loading}
                   scroll     = {{x:true}}
                   pagination = {false}
                   bordered
                   defaultExpandedRowKeys={['total' || 'Add. Services total']} />
        </Card>
    )
}